import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  map,
  catchError,
} from 'rxjs/operators';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from '../global/global.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { IChangePassword } from '../../interface/change-password.interface';
import { ISuccessResponseType1 } from '../../interface/success-response.interface';
import { MenuSubMenuHeaderConfigurationService } from '@service/header-configuration/menu-sub-menu-header-configuration.service';
import { IAclMenuDetails } from '../../interface/acl/acl.interface';
const jwthelper = new JwtHelperService();
@Injectable({
  providedIn: 'root',
})
export class AutenticationService {
  isAutenticated = false;
  isAppLogin = true;
  private storeUserDataOnLocalStorageObs$: BehaviorSubject<any> =
    new BehaviorSubject(null);
  constructor(
    private router: Router,
    private http: HttpClient,
    public globalService: GlobalService,
    private readonly menuSubMenuHeaderConfigurationService: MenuSubMenuHeaderConfigurationService
  ) {}

  getStoreUserDataOnLocalStorageObs(): Observable<any> {
    return this.storeUserDataOnLocalStorageObs$.asObservable();
  }

  setUserDataOnLocalStorageObs(data) {
    this.storeUserDataOnLocalStorageObs$.next(data);
  }

  loggedIn() {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        if (jwthelper.isTokenExpired(token)) {
          // true means token expired.
          // if(this.getBracToken()){
          //   localStorage.clear();
          //   window.location.href = this.globalService.ssoBracUrl;
          // } else {
          // }
          localStorage.clear();
          return false;
        } else {
          return true;
        }
      } catch (error) {
        this.logout();
      }
    } else {
      return false;
    }
    // return !!localStorage.getItem('token');
  }

  signIn(username: string, password: string): Observable<any> {
    // console.log('<========Token 0Auth wtih (grant_type: password) service called========>');
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    this.menuSubMenuHeaderConfigurationService.setMenuInfo(
      this.getLoginMenuHeaders()
    );
    const body = JSON.stringify({ email: username, password });
    return this.http
      .post(this.globalService.apiURL_UPGAuth + '/account/login', body, {
        headers,
      })
      .pipe(
        map((x: Response) => x),
        map((x: any) => x.result),
        map((x) => {
          // this.setSessionUser(x.access_token); //// open this later
          // this.setToken(x.access_token); //// open this later

          // localStorage.setItem('token', JSON.stringify(x.access_token));
          return x;
        }),
        catchError((error: Response) => {
          return throwError(error);
        })
      );
  }

  private getLoginMenuHeaders() {
    return {
      menu_id: 'w_m_login',
      menu_name: 'Login',
      submenu_id: 'w_sm_login',
      submenu_name: 'Login',
    } as IAclMenuDetails;
  }

  getToken() {
    return localStorage.getItem('token');
  }

  setToken(token) {
    localStorage.setItem('token', JSON.stringify(token));
  }

  logout() {
    if (localStorage.getItem('id_token') !== null) {
      this.ssoLogout(localStorage.getItem('id_token'));
    }
    localStorage.clear();
    return true;
  }

  setSessionUser(token) {
    try {
      const tokenDecode = jwthelper.decodeToken(token);
      delete tokenDecode.iat;
      delete tokenDecode.iss;
      localStorage.setItem('sessionUser', JSON.stringify(tokenDecode));
      return true;
    } catch (error) {
      return false;
    }
  }

  getSessionUser() {
    return JSON.parse(localStorage.getItem('sessionUser'));
  }

  setBracToken(token) {
    localStorage.setItem('multipass', JSON.stringify(token));
  }

  getBracToken() {
    return JSON.parse(localStorage.getItem('multipass'));
  }

  getUserInfo() {
    return JSON.parse(localStorage.getItem('user'));
  }

  setUserInfo(user) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  getLoginUserRole() {
    const sUser = JSON.parse(localStorage.getItem('sessionUser'));
    return sUser.role;
  }

  isAdminRole() {
    // return true;
    const sUser = JSON.parse(localStorage.getItem('sessionUser'));
    if (sUser?.role?.short_form.toLowerCase() == 'admin') {
      return true;
    } else {
      return false;
    }
  }

  isSMORole() {
    // return true;
    const sUser = JSON.parse(localStorage.getItem('sessionUser'));
    if (sUser?.role?.short_form.toLowerCase() == 'smo') {
      return true;
    } else {
      return false;
    }
  }

  isRole(roleShortForm: string): boolean {
    const sUser = JSON.parse(localStorage.getItem('sessionUser'));
    return (
      sUser?.role?.short_form.toLowerCase() === roleShortForm.toLowerCase()
    );
  }

  changePassword(body: IChangePassword): Observable<ISuccessResponseType1> {
    return this.http
      .patch(this.globalService.apiURL_UPGAuth + '/account/resetpassword', body)
      .pipe(
        map((x: ISuccessResponseType1) => x),
        catchError((error: Response) => throwError(error))
      );
  }

  getACLMenuInfo() {
    return JSON.parse(localStorage.getItem('acl'));
  }

  setACLMenuInfo(data) {
    localStorage.setItem('acl', JSON.stringify(data));
  }

  decrypt(token) {
    return jwthelper.decodeToken(token);
  }

  ssoLogin(pin) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const body = JSON.stringify({ pin });
    return this.http
      .post(this.globalService.apiURL_UPGAuth + '/account/sso-login', body, {
        headers,
      })
      .pipe(
        map((x: any) => x.result),
        catchError((error: Response) => throwError(error))
      );
  }

  ssoLogout(idToken) {
    setTimeout(() => {
      window.location.href =
        this.globalService.ssoBracLogoutURL +
        '/realms/brac/protocol/openid-connect/logout?id_token_hint=' +
        idToken +
        '&post_logout_redirect_uri=' +
        this.globalService.domain +
        'auth/login';
      this.isAppLogin = true;
    }, 2000);
  }
}
